import React from 'react';
import { AlertTriangle, TrendingDown, Eye, CheckCircle } from 'lucide-react';
import { computeForumRisk, type RiskLevel } from '../utils/forumRisk';
import type { ForumBase } from '../types/forum';
import { useAuth } from '../contexts/AuthContext';
import { canSeeInternalRiskLabels } from '../utils/isSiteAdmin';

const styles: Record<RiskLevel, { bg: string; icon: React.ReactNode }> = {
  healthy: {
    bg: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300',
    icon: <CheckCircle size={12} />,
  },
  watch: {
    bg: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300',
    icon: <Eye size={12} />,
  },
  declining: {
    bg: 'bg-orange-100 text-orange-800 dark:bg-orange-900/40 dark:text-orange-300',
    icon: <TrendingDown size={12} />,
  },
  critical: {
    bg: 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300',
    icon: <AlertTriangle size={12} />,
  },
};

/** Ziyaretçilere gösterilmeyen dahili etiketler */
const ADMIN_ONLY_LEVELS: RiskLevel[] = ['watch'];

const ForumRiskBadge: React.FC<{ forum: ForumBase; className?: string }> = ({ forum, className = '' }) => {
  const { user, loading } = useAuth();
  const risk = computeForumRisk(forum);
  const isAdmin = canSeeInternalRiskLabels(user);

  if (ADMIN_ONLY_LEVELS.includes(risk.level) && (!isAdmin || loading)) {
    return null;
  }

  if (risk.level === 'healthy' && forum.is_active !== false) {
    return null;
  }

  const s = styles[risk.level];
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${s.bg} ${className}`}
    >
      {s.icon}
      {risk.label}
    </span>
  );
};

export default ForumRiskBadge;
